<template>
  <div>
    <div
      class="head"
      v-bind:style="{
        backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), url(' + imgUrl1 + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }"
    >
      <div class="title">Plant Mitochondrial Genome Database</div>
      <div class="search">
        <el-input
          v-model="input"
          placeholder="Enter Latin or Chinese name"
          clearable
          @keyup.enter.native="search"
        ></el-input>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="search"
        ></el-button>
      </div>
    </div>

    <div class="body_container">
      <div class="leftBox">
        <div class="text_container">
          <div class="text">
            &nbsp;&nbsp;&nbsp;&nbsp;Welcome to Plant Mitochondrial Genome
            Database (PMGD), a comprehensive online resource designed to serve
            as a hub for researchers, educators, and students interested in the
            fascinating world of plant genetics. PMGD currently comprises 
            <span class="number">1,829</span> genomes from <span class="number">5</span>
            major plant groups, <span class="number">42</span> classes,
            <span class="number">125</span> orders, <span class="number">274</span> families,
            <span class="number">768</span> genera, and <span class="number">1,307</span>
            plant species. It offers a wealth of information for those eager to explore the
            dynamics and maintenance of plant mitogenomes.
          </div>
        </div>

        <div class="intro">
          <span
            style="
              font-size: 23px;
              font-weight: 700;
              color: #696565;
              margin: 0 200px 10px 20px;
              width: 880px;
            "
            >Resources and Available Tools</span
          >
          <el-card
            :body-style="{ padding: '0px' }"
            shadow="hover"
            class="introBox"
            @click.native="goTo('Genomes')"
          >
            <img src="../images/genome.png" class="image" style="margin:auto;width: 150px;object-fit: cover;"/>
            <div class="introTitle">Mitogenomes</div>
          </el-card>
          <el-card
            :body-style="{ padding: '0px' }"
            shadow="hover"
            class="introBox"
            @click.native="goTo('Genes')"
          >
            <img src="../images/gene.png" class="image" style="margin: auto;width: 170px;object-fit: cover;"/>
            <div class="introTitle">Genes</div>
          </el-card>
          <el-card
            :body-style="{ padding: '0px' }"
            shadow="hover"
            class="introBox"
            @click.native="goTo('SequenceServer')"
          >
            <img src="../images/sequenceserver.png" class="image" style="margin:auto;width: 200px;object-fit: cover;" />
            <div class="introTitle">SequenceServer</div>
          </el-card>
          <el-card
            :body-style="{ padding: '0px' }"
            shadow="hover"
            class="introBox"
            @click.native="goTo('JBrowse')"
          >
            <img src="../images/jbrowse.png" class="image" style="margin:auto;padding: 2px;width: 260px;object-fit: cover;"/>
            <div class="introTitle">JBrowse</div>
          </el-card>
          <el-card
            :body-style="{ padding: '0px' }"
            shadow="hover"
            class="introBox"
            @click.native="goTo('Statistics')"
          >
            <img src="../images/statistics.png" class="image" style="margin:auto;width: 250px;object-fit: cover;"/>
            <div class="introTitle">Statistics</div>
          </el-card>
          <el-card
            :body-style="{ padding: '0px' }"
            shadow="hover"
            class="introBox"
            @click.native="goTo('PublicationHome')"
          >
            <img src="../images/publications.png" class="image" />
            <div class="introTitle">Publications</div>
          </el-card>
        </div>
        <el-card :body-style="{ padding: '0px',  }" shadow="never" class="graph">
          <Scatter />
        </el-card>
      </div>
      <div class="rightBox">
        <!-- <el-carousel
          trigger="click"
          height=" 300px"
          :interval="3000"
          arrow="always"
          style="width: 400px"
          indicator-position="outside"
        >
          <el-carousel-item v-for="item in imageUrls" :key="item">
            <el-image
              :src="item"
              style="width: 400px; height: 300px"
              alt="Image not found..."
              :title="item"
              fit="contain"
            ></el-image>
          </el-carousel-item>
        </el-carousel> -->
      <!-- 插入一个物种轮播图片 -->
        <div class="infosContainer" style="height: 240px; overflow: hidden; margin-top: 10px; margin-bottom: 20px;">
          <el-carousel
            trigger="click"
            height="240px"
            :interval="3000"
            arrow="hover"
            style="width: 100%; height: 100%; border-radius: 8px;"
          >
            <el-carousel-item v-for="(item, index) in imageUrls" :key="index">
              <el-image
                :src="item"
                style="width: 100%; height: 100%;"
                alt="Species Image"
                fit="cover"
              ></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="infosContainer" style="height: auto; padding: 40px 20px; display: flex; align-items: center; justify-content: center; box-sizing: border-box; margin-bottom: 20px;">
          <el-button @click="submitDialogVisible = true" style="width: 100%; font-size: 20px; font-weight: bold; padding: 18px 0; border-radius: 50px; letter-spacing: 1px; background: #a29bfe; border: none; color: #ffffff; box-shadow: 0 6px 16px rgba(162, 155, 254, 0.4);">
            <i class="el-icon-upload" style="margin-right: 8px; font-size: 24px; vertical-align: middle;"></i> 
            <span style="vertical-align: middle;">Submit Data</span>
          </el-button>
        </div>
        <div class="infosContainer" style="height: 210px;">
          <div class="infosTitle" >
            <svg
              t="1698830529476"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3772"
              width="200"
              height="200"
            >
              <path
                d="M922.794667 653.056L1024 711.893333 483.498667 1024 0 743.082667l101.205333-58.368 382.165334 222.122666 439.424-253.781333zM475.349333 165.034667l0.725334-0.128 7.466666 7.765333-0.725333 0.128a42.368 42.368 0 0 0-12.885333 4.608c-4.352 2.56-5.333333 5.077333-2.688 6.613333 2.645333 1.578667 6.528 0.981333 15.744-1.536 12.885333-3.2 22.101333-2.944 29.354666 1.28 7.722667 4.48 10.837333 12.8-4.736 21.76a60.074667 60.074667 0 0 1-18.005333 6.741334l-0.725333 0.128-7.936-7.722667 0.938666-0.298667a52.48 52.48 0 0 0 15.829334-5.461333c4.608-2.645333 5.845333-5.333333 2.688-7.168-2.901333-1.664-6.784-1.408-15.018667 0.853333-12.885333 3.797333-23.082667 3.541333-30.08-0.554666-9.386667-5.461333-7.936-13.909333 4.010667-20.778667a55.893333 55.893333 0 0 1 16.042666-6.229333z m0.64 57.898666l-13.397333 7.722667-41.130667-16.298667 27.264 24.277334-13.610666 7.893333-64.597334-23.210667 13.568-7.850666 42.837334 17.28-28.928-25.258667 13.141333-7.594667 42.112 16.853334-28.970667-24.448 13.098667-7.594667 38.613333 38.229333z m-99.242666 9.088l-19.968 11.52 9.429333 5.461334 18.986667-10.922667 10.666666 6.186667-18.986666 10.922666 10.88 6.357334 21.162666-12.202667 10.666667 6.186667-34.090667 19.669333-52.224-30.378667 32.853334-18.944 10.624 6.144z m-0.042667 48.213334l-13.141333 7.594666-54.229334-9.856 35.541334 20.650667-11.946667 6.869333-52.181333-30.336 14.592-8.448 49.408 8.746667-32.170667-18.688 11.904-6.869333 52.224 30.336z m270.421333-93.141334l-324.266666 187.264-26.837334-15.616 324.309334-187.264 26.794666 15.616z m53.888 31.36l-80.981333 46.762667-26.837333-15.573333 81.024-46.805334 26.794666 15.616z m-54.314666 93.525334l-108.288 62.506666-80.512-46.762666 108.288-62.506667 80.512 46.762667z m-188.928 46.933333L376.746667 405.674667l-26.837334-15.616L430.933333 343.296l26.837334 15.616z m296.917333-109.269333L673.706667 296.405333l-26.837334-15.616 81.024-46.762666 26.794667 15.616z m-243.285333 140.416l-81.024 46.805333-26.837334-15.616 81.024-46.762667 26.837334 15.573334z m350.933333-140.416L540.16 62.378667 107.605333 312.106667l322.218667 187.264 432.512-249.728zM1024 280.917333l-540.629333 312.106667L0 312.106667 540.501333 0 1024 280.917333z m-497.962667 386.005334l-42.794666 24.746666-42.709334-24.874666-339.968-197.589334L0 527.232l483.498667 280.917333L1024 496.042667l-100.650667-58.538667-397.312 229.418667z"
                p-id="3773"
              ></path>
            </svg>

            <div>News & Updates</div>
          </div>
          <div class="scroll-container" style="height: 140px;">
            <div class="scroll-content">
            <p class="info_text">
              <svg
                t="1731565778365"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5154"
                width="12"
                height="12"
              >
                <path
                  d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                  p-id="5155"
                ></path>
              </svg>

              A total of <span class="number">1,829</span> mitochondrial genomes
              from <span class="number">1,307</span> species are integrated and
              curated. (<span class="number">2026.05.31</span>)
            </p>
            <p class="info_text">
              <svg
                t="1731565778365"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5154"
                width="12"
                height="12"
              >
                <path
                  d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                  p-id="5155"
                ></path>
              </svg>

              A total of <span class="number">1,719</span> mitochondrial genomes
              from <span class="number">1,214</span> species are integrated and
              curated. (<span class="number">2025.10.31</span>)
            </p>
            <p class="info_text">
              <svg
                t="1731565778365"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5154"
                width="12"
                height="12"
              >
                <path
                  d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                  p-id="5155"
                ></path>
              </svg>

              A total of <span class="number">1,505</span> mitochondrial genomes
              from <span class="number">1,046</span> species are integrated and
              curated. (<span class="number">2024.09.02</span>)
            </p>
            <p class="info_text">
              <svg
                t="1731565778365"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5154"
                width="12"
                height="12"
              >
                <path
                  d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                  p-id="5155"
                ></path>
              </svg>
              A total of <span class="number">1,155</span> mitochondrial genomes
              are integrated and curated. (<span class="number">2024.01.02</span
              >)
            </p>
            
<!-- 为了实现无缝循环滚动，复制一遍上面的内容 -->
            <p class="info_text">
              <svg
                t="1731565778365"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5154"
                width="12"
                height="12"
              >
                <path
                  d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                  p-id="5155"
                ></path>
              </svg>

              A total of <span class="number">1,829</span> mitochondrial genomes
              from <span class="number">1,307</span> species are integrated and
              curated. (<span class="number">2026.05.31</span>)
            </p>
            <p class="info_text">
              <svg
                t="1731565778365"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5154"
                width="12"
                height="12"
              >
                <path
                  d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                  p-id="5155"
                ></path>
              </svg>

              A total of <span class="number">1,719</span> mitochondrial genomes
              from <span class="number">1,214</span> species are integrated and
              curated. (<span class="number">2025.10.31</span>)
            </p>
            <p class="info_text">
              <svg
                t="1731565778365"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5154"
                width="12"
                height="12"
              >
                <path
                  d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                  p-id="5155"
                ></path>
              </svg>

              A total of <span class="number">1,505</span> mitochondrial genomes
              from <span class="number">1,046</span> species are integrated and
              curated. (<span class="number">2024.09.02</span>)
            </p>
            <p class="info_text">
              <svg
                t="1731565778365"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5154"
                width="12"
                height="12"
              >
                <path
                  d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                  p-id="5155"
                ></path>
              </svg>
              A total of <span class="number">1,155</span> mitochondrial genomes
              are integrated and curated. (<span class="number">2024.01.02</span
              >)
            </p>
            </div>
          </div>

        </div>
        <div class="infosContainer" style="height: 210px">
          <div class="infosTitle">
            <svg
              t="1698830945835"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6683"
              width="200"
              height="200"
            >
              <path
                d="M696 128c-53.504 0-104.256 21.12-142.016 59.008l-46.976 46.976A200.064 200.064 0 0 0 448 376c0 25.376 4.864 50.112 14.016 72.992l51.968-52A137.12 137.12 0 0 1 552 279.04l47.008-47.008A136.96 136.96 0 0 1 696 192c36.384 0 70.24 14.24 96 40a136.768 136.768 0 0 1 0 192.992l-47.008 47.008A136.96 136.96 0 0 1 648 512c-7.136 0-14.112-0.736-20.992-2.016l-52 52.032A196.992 196.992 0 0 0 648 576c53.504 0 104.256-21.12 142.016-59.008l46.976-46.976A200.064 200.064 0 0 0 896 328c0-53.504-21.12-103.136-59.008-140.992A197.536 197.536 0 0 0 696 128z m-79.008 232.992l-256 256 46.016 46.016 256-256zM376 448c-53.504 0-104.256 21.12-142.016 59.008l-46.976 47.008A200.064 200.064 0 0 0 128 696c0 53.504 21.12 103.136 59.008 140.992A197.536 197.536 0 0 0 328 896c53.504 0 104.256-21.12 142.016-59.008l46.976-46.976A200.064 200.064 0 0 0 576 648c0-25.376-4.864-50.112-14.016-72.992l-52 52a137.12 137.12 0 0 1-37.984 117.984l-47.008 47.008A136.96 136.96 0 0 1 328 832a134.656 134.656 0 0 1-96-40 136.768 136.768 0 0 1 0-192.992l47.008-47.008A136.96 136.96 0 0 1 376 512c7.136 0 14.112 0.736 20.992 2.016l52-52A196.992 196.992 0 0 0 376 448z"
                p-id="6684"
              ></path>
            </svg>
            Links
          </div>
          
          <p class="info_text">
            <svg
              t="1731565778365"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5154"
              width="12"
              height="12"
            >
              <path
                d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                p-id="5155"
              ></path>
            </svg>
            <el-tooltip
            effect="dark"
            content="PMAT: an efficient plant mitogenome assembly toolkit using low-coverage HiFi sequencing data"
            placement="top"
            >
            <el-link
              class="link-text-sby"
              type="primary"
              href="https://github.com/bichangwei/PMAT"
              target="_blank"
              :underline="false"
              >PMAT: an efficient plant mitogenome assembly toolkit using low-coverage HiFi sequencing data</el-link
            >
            </el-tooltip>
          </p>
          <p class="info_text">
            <svg
              t="1731565778365"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5154"
              width="12"
              height="12"
            >
              <path
                d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                p-id="5155"
              ></path>
            </svg>
            <el-link
              type="primary"
              href="https://ngdc.cncb.ac.cn/cgir/"
              target="_blank"
              :underline="false"
              >Chloroplast Genome Information Resource</el-link
            >
          </p>
          <p class="info_text">
            <svg
              t="1731565778365"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5154"
              width="12"
              height="12"
            >
              <path
                d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                p-id="5155"
              ></path>
            </svg>
            <el-link
              type="primary"
              href="http://www.1kmpg.cn/pmga/"
              target="_blank"
              :underline="false"
              >PMGA: A Plant Mitochondrial Genome Annotator</el-link
            >
          </p>
          <p class="info_text">
            <svg
              t="1731565778365"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5154"
              width="12"
              height="12"
            >
              <path
                d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                p-id="5155"
              ></path>
            </svg>
            <el-tooltip
            effect="dark"
            content="Master graph: an essential integrated assembly model for the plant mitogenome based on a graph-based framework"
            placement="top"
            >

              <el-link
              class="link-text-sby"
              type="primary"
              href="https://github.com/hwc2021/GSAT"
              target="_blank"
              :underline="false"
              >
              Master graph: an essential integrated assembly model for the plant mitogenome based on a graph-based framework</el-link
              >
            </el-tooltip>
          </p>
          <!-- <p class="info_text">
            <svg
              t="1731565778365"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5154"
              width="12"
              height="12"
            >
              <path
                d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                p-id="5155"
              ></path>
            </svg>
            <el-link
              type="primary"
              href="https://ngdc.cncb.ac.cn/"
              target="_blank"
              :underline="false"
              >National Genomics Data Center</el-link
            >
          </p>
          
          <p class="info_text" style="display: flex; flex-wrap: wrap">
            <svg
              t="1731565778365"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5154"
              width="12"
              height="12"
            >
              <path
                d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                p-id="5155"
              ></path>
            </svg>
            <el-link
              type="primary"
              href="https://ngdc.cncb.ac.cn/cgir/"
              target="_blank"
              :underline="false"
              style="width: 280px"
              >A comprehensive organelle genomes database for algae cpDNA and
              mtDNA</el-link
            >
          </p>
          <p class="info_text" style="display: flex; flex-wrap: wrap">
            <svg
              t="1731565778365"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5154"
              width="12"
              height="12"
            >
              <path
                d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                p-id="5155"
              ></path>
            </svg>
            <el-link
              type="primary"
              href="https://www.researchgate.net/profile/Changwei-Bi"
              target="_blank"
              :underline="false"
              >Nanjing Forestry University Changwei Bi</el-link
            >
          </p> -->
        </div>
        <div class="infosContainer" style="height: 212px">
          <div class="infosTitle">
            <svg 
            class="icon" 
            width="200" 
            height="200" 
            viewBox="0 0 1024 1024" 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg">
              <path d="M499.437996 54.982714l-17.458679-6.850107-170.343358-45.465309c-32.43192-8.486858-53.103481 3.273502-61.650959 35.3417l-202.835898 842.805589c-8.486858 32.856263 3.212882 53.527824 35.705422 62.439024l170.343358 45.404689c32.856263 8.911201 53.527824-3.334123 62.075302-36.129766l202.896519-842.381245c6.910727-25.884916 0.727445-44.19228-18.792327-55.164575z m-82.807483 293.220933a38.554582 38.554582 0 0 1-12.124082 19.459152 18.974189 18.974189 0 0 1-16.549373 4.48591h-1.333649l-154.46081-41.767463c-6.062041-1.576131-10.184229-5.577078-12.609045-12.548426a35.523561 35.523561 0 0 1-1.212409-22.308311 32.128818 32.128818 0 0 1 12.184703-18.671087 17.519299 17.519299 0 0 1 17.458679-5.273976l154.46081 41.767464h0.848685c1.030547 0.303102 1.757992 1.212408 2.727919 1.818612a21.702108 21.702108 0 0 1 9.456784 11.154156 29.764622 29.764622 0 0 1 2.546058 10.36609 38.493962 38.493962 0 0 1-1.212409 11.517879z m26.066777-101.963533c-0.181861 2.242955-0.181861 4.36467-0.909306 6.668245a33.341227 33.341227 0 0 1-7.941274 14.124556c-1.333649 1.51551-2.546057 3.273502-4.243429 4.546531-1.576131 1.45489-3.273502 2.182335-4.970874 3.03102a16.12503 16.12503 0 0 1-11.214776 2.242956h-0.788065l-154.52143-41.343121a21.702108 21.702108 0 0 1-13.397111-13.397111 30.977031 30.977031 0 0 1-1.515511-15.518826c0.181861-2.121714 0.181861-4.243429 0.727445-6.425763 0.727445-2.303576 1.818612-4.182808 2.84916-6.243903a35.099219 35.099219 0 0 1 9.335543-12.851527c5.81956-4.849633 11.82098-6.486384 17.883022-4.42529l154.460809 41.343121h0.788066a18.307364 18.307364 0 0 1 8.365617 7.274449c1.333649 1.636751 2.424816 3.273502 3.394743 5.334596a31.219512 31.219512 0 0 1 2.364196 10.729813c0.121241 1.636751-0.484963 3.273502-0.666825 5.031494z m287.946957-160.886574c-3.273502 7.698792-4.849633 16.549372-4.849633 26.672981v874.146342c0 10.487331 1.576131 19.519773 4.849633 26.794222 3.637225 7.213829 8.123135 10.911674 13.397111 10.911674s9.335543-3.697845 12.912148-10.911674a57.771253 57.771253 0 0 0 5.637699-26.794222v-874.146342a61.529718 61.529718 0 0 0-5.637699-26.672981c-3.637225-7.39569-7.638172-11.032915-12.912148-11.032915s-9.699266 3.576604-13.397111 11.032915z m-22.247691 26.672981c0-10.062988-1.576131-18.974189-4.849633-26.672981-4.122188-7.33507-8.608099-10.911674-13.821454-10.911674-5.273976 0-9.335543 3.576604-12.912147 10.911674a61.711579 61.711579 0 0 0-5.637699 26.672981v874.146342c0 10.426711 2.000474 19.519773 5.637699 26.794222 3.697845 7.213829 7.638172 10.911674 12.912147 10.911674 5.213355 0 9.699266-3.697845 13.760834-10.911674 3.334123-7.274449 4.849633-16.367511 4.849633-26.794222z m239.268766-26.672981c-3.273502 7.698792-4.849633 16.549372-4.849632 26.672981v874.146342c0 10.487331 1.576131 19.519773 4.849632 26.794222 3.637225 7.213829 8.001894 10.911674 13.336491 10.911674s9.335543-3.697845 12.972768-10.911674a59.468624 59.468624 0 0 0 5.516458-26.794222v-874.146342a61.529718 61.529718 0 0 0-5.516458-26.672981c-3.637225-7.39569-7.638172-11.032915-13.033388-11.032915-5.273976 0-9.638646 3.576604-13.275871 11.032915z m-22.308311 26.672981c0-10.062988-1.636751-18.974189-5.031494-26.672981-4.000947-7.33507-8.486858-10.911674-13.639593-10.911674-5.273976 0-9.396164 3.576604-13.033389 10.911674a61.711579 61.711579 0 0 0-5.637698 26.672981v874.146342c0 10.426711 2.000474 19.519773 5.637698 26.794222 3.637225 7.213829 7.759413 10.911674 13.033389 10.911674 5.152735 0 9.578025-3.697845 13.639593-10.911674a63.530192 63.530192 0 0 0 5.031494-26.794222z m-297.282501-33.219985a37.463415 37.463415 0 0 0-26.854842-10.972295 37.645276 37.645276 0 0 0-27.036704 10.911674 36.675349 36.675349 0 0 0-10.911674 26.794222v880.208383c0 10.487331 3.637225 19.459152 10.911674 26.794222a36.73597 36.73597 0 0 0 27.036704 11.336017 36.554108 36.554108 0 0 0 26.854842-11.336017 36.311627 36.311627 0 0 0 11.032915-26.794222v-880.208383a36.311627 36.311627 0 0 0-11.032915-26.733601z m171.131423 0a36.554108 36.554108 0 0 0-10.911674 26.733601v880.208383c0 10.487331 3.637225 19.459152 10.911674 26.794222a36.554108 36.554108 0 0 0 26.854843 11.336017 37.220933 37.220933 0 0 0 27.157945-11.336017 36.675349 36.675349 0 0 0 10.911674-26.794222v-880.208383a36.554108 36.554108 0 0 0-10.911674-26.733601 38.19086 38.19086 0 0 0-27.157945-10.972295 37.402794 37.402794 0 0 0-26.854843 10.911674z" fill="#8a8a8a" /><path d="M920.325517 1012.967085a32.189439 32.189439 0 0 1-45.52593 0l-113.784513-113.784513a227.387166 227.387166 0 1 1 45.525929-45.52593l113.784514 113.784514a32.189439 32.189439 0 0 1 0 45.525929z m-293.766517-454.834951a161.068435 161.068435 0 1 0 161.068435 161.007814 161.068435 161.068435 0 0 0-161.068435-161.007814z" fill="#2c2c2c" /></svg>
            Publications
          </div>
          <div class="scroll-container" style="height: 140px;">
            <div class="scroll-content">
              <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1016/j.tplants.2023.12.014', '_blank')">
                <svg
                  t="1731565778365"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5154"
                  width="12"
                  height="12"
                >
                  <path
                    d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                    p-id="5155"
                  ></path>
                </svg>
                Plant organellar genomes: much done, much more to do
              </p>
              <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1093/hr/uhae023', '_blank')">
                <svg
                  t="1731565778365"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5154"
                  width="12"
                  height="12"
                >
                  <path
                    d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                    p-id="5155"
                  ></path>
                </svg>
                PMAT: an efficient plant mitogenome assembly toolkit using low-coverage HiFi sequencing data
              </p>
              <!-- <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1016/j.tplants.2023.12.014', '_blank')">
                ...
                Plant organellar genomes: much done, much more to do
              </p> -->
              <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1016/j.xplc.2024.101191', '_blank')">
                <svg
                  t="1731565778365"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5154"
                  width="12"
                  height="12"
                >
                  <path
                    d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                    p-id="5155"
                  ></path>
                </svg>
                PMGA: A plant mitochondrial genome annotator
              </p>
              <!-- <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1111/pbi.70249', '_blank')">
                ...
                Advance in the assembly of the plant mitochondrial genomes using high-throughput DNA sequencing data of total cellular DNAs
              </p> -->

              <!-- 为了无缝循环，复制一份内容 -->
              <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1016/j.tplants.2023.12.014', '_blank')">
                <svg
                  t="1731565778365"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5154"
                  width="12"
                  height="12"
                >
                  <path
                    d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                    p-id="5155"
                  ></path>
                </svg>
                Plant organellar genomes: much done, much more to do
              </p>
              <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1093/hr/uhae023', '_blank')">
                <svg
                  t="1731565778365"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5154"
                  width="12"
                  height="12"
                >
                  <path
                    d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                    p-id="5155"
                  ></path>
                </svg>
                PMAT: an efficient plant mitogenome assembly toolkit using low-coverage HiFi sequencing data
              </p>
              <!-- <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1016/j.tplants.2023.12.014', '_blank')">
                ...
                Plant organellar genomes: much done, much more to do
              </p> -->
              <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1016/j.xplc.2024.101191', '_blank')">
                <svg
                  t="1731565778365"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5154"
                  width="12"
                  height="12"
                >
                  <path
                    d="M317.1 510.7a191.4 191.4 0 1 0 382.8 0 191.4 191.4 0 1 0-382.8 0z"
                    p-id="5155"
                  ></path>
                </svg>
                PMGA: A plant mitochondrial genome annotator
              </p>
              <!-- <p class="info_text info_essay_text" onclick="window.open('https://doi.org/10.1111/pbi.70249', '_blank')">
                ...
                Advance in the assembly of the plant mitochondrial genomes using high-throughput DNA sequencing data of total cellular DNAs
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Submit Form Dialog -->
    <el-dialog     
      title="Submit Mitochondrial Genome Data"
      :visible.sync="submitDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      custom-class="submit-dialog"
    >
      <div style="text-align: center; padding: 20px 10px;">
        <i class="el-icon-message" style="font-size: 50px; color: #7b1fa2; margin-bottom: 20px;"></i>
        <h3 style="color: #303133; font-size: 22px; margin-bottom: 15px;">Submit Your Data via Email</h3>
        <p style="color: #606266; font-size: 16px; line-height: 1.6; margin-bottom: 30px; word-break: normal; overflow-wrap: break-word;">
          To ensure data quality and standardized processing, please package your mitochondrial
          genome data (.gb and .fasta formats) along with a brief description and send it directly to our curation team.
        </p>
        
        <div style="background-color: #f3e5f5; border: 2px dashed #7b1fa2; border-radius: 12px; padding: 20px; display: inline-block; margin-bottom: 20px; cursor: pointer;" @click="window.location.href='mailto:njfu_pmgd@163.com'">
          <a href="mailto:njfu_pmgd@163.com" style="font-size: 24px; font-weight: bold; color: #4a148c; text-decoration: none;">
            njfu_pmgd@163.com
          </a>
        </div>
        
        <p style="color: #909399; font-size: 14px; word-break: normal; overflow-wrap: break-word;">
          We will review your submission and get back to you as soon as possible.
        </p>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center;">
        <el-button type="primary" style="background: linear-gradient(135deg, #7b1fa2, #4a148c); border: none; padding: 12px 40px; border-radius: 30px; font-size: 16px;" @click="submitDialogVisible = false">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import * as echarts from "echarts";
import Scatter from "../components/Scatter.vue";
// import GenomesPie from "../components/GenomesPie.vue";
// import GenesPie from "../components/GenesPie.vue";
import { ref } from "vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "GeneHome",
  components: { Scatter },
  data() {
    return {
      submitDialogVisible: false,
      submitForm: {
        name: '',
        email: '',
        species: '',
        description: ''
      },
      data1: {
        name: null,
        value: null,
        children: [
          {
            name: "ATP synthase",
            value: 282,
            children: [
              {
                name: "atp6",
                value: 50,
                children: null,
              },
              {
                name: "atp1",
                value: 58,
                children: null,
              },
              {
                name: "atp9",
                value: 61,
                children: null,
              },
              {
                name: "atp8",
                value: 65,
                children: null,
              },
              {
                name: "atp4",
                value: 48,
                children: null,
              },
            ],
          },
          {
            name: "Cytochrome c biogenesis",
            value: 167,
            children: [
              {
                name: "ccmB",
                value: 45,
                children: null,
              },
              {
                name: "ccmC",
                value: 47,
                children: null,
              },
              {
                name: "ccmFn",
                value: 30,
                children: null,
              },
              {
                name: "ccmFc",
                value: 45,
                children: null,
              },
            ],
          },
          {
            name: "Ubichinol cytochrome c reductase",
            value: 69,
            children: [
              {
                name: "cob",
                value: 69,
                children: null,
              },
            ],
          },
          {
            name: "Cytochrome c oxidase",
            value: 197,
            children: [
              {
                name: "cox1",
                value: 63,
                children: null,
              },
              {
                name: "cox3",
                value: 68,
                children: null,
              },
              {
                name: "cox2",
                value: 66,
                children: null,
              },
            ],
          },
          {
            name: "Maturases",
            value: 27,
            children: [
              {
                name: "matR",
                value: 27,
                children: null,
              },
            ],
          },
          {
            name: "Transport membrane protein",
            value: 29,
            children: [
              {
                name: "mttB",
                value: 29,
                children: null,
              },
            ],
          },
          {
            name: "NADH dehydrogenase",
            value: 492,
            children: [
              {
                name: "nad5",
                value: 68,
                children: null,
              },
              {
                name: "nad4L",
                value: 45,
                children: null,
              },
              {
                name: "nad4",
                value: 61,
                children: null,
              },
              {
                name: "nad2",
                value: 51,
                children: null,
              },
              {
                name: "nad1",
                value: 45,
                children: null,
              },
              {
                name: "nad6",
                value: 62,
                children: null,
              },
              {
                name: "nad3",
                value: 61,
                children: null,
              },
              {
                name: "nad7",
                value: 48,
                children: null,
              },
              {
                name: "nad9",
                value: 51,
                children: null,
              },
            ],
          },
          {
            name: "Ribosomal proteins (LSU)",
            value: 172,
            children: [
              {
                name: "rpl16",
                value: 37,
                children: null,
              },
              {
                name: "rpl2",
                value: 39,
                children: null,
              },
              {
                name: "rpl5",
                value: 58,
                children: null,
              },
              {
                name: "rpl6",
                value: 20,
                children: null,
              },
              {
                name: "rpl10",
                value: 18,
                children: null,
              },
            ],
          },
          {
            name: "Ribosomal proteins (SSU)",
            value: 533,
            children: [
              {
                name: "rps19",
                value: 40,
                children: null,
              },
              {
                name: "rps14",
                value: 48,
                children: null,
              },
              {
                name: "rps11",
                value: 31,
                children: null,
              },
              {
                name: "rps13",
                value: 48,
                children: null,
              },
              {
                name: "rps4",
                value: 59,
                children: null,
              },
              {
                name: "rps12",
                value: 67,
                children: null,
              },
              {
                name: "rps7",
                value: 45,
                children: null,
              },
              {
                name: "rps10",
                value: 26,
                children: null,
              },
              {
                name: "rps3",
                value: 60,
                children: null,
              },
              {
                name: "rps2",
                value: 43,
                children: null,
              },
              {
                name: "rps8",
                value: 18,
                children: null,
              },
              {
                name: "rps1",
                value: 48,
                children: null,
              },
            ],
          },
          {
            name: "Succinate dehydrogenase",
            value: 64,
            children: [
              {
                name: "sdh3",
                value: 33,
                children: null,
              },
              {
                name: "sdh4",
                value: 31,
                children: null,
              },
            ],
          },
          {
            name: "Transfer RNAs",
            value: 41,
            children: [],
          },
          {
            name: "Ribosomal RNAs",
            value: 3,
            children: [],
          },
        ],
      },
      carousel_data: [
        { info: "This is infomation A" },
        { info: "This is infomation B" },
        { info: "This is infomation C" },
      ],
      imgUrl1: ref(require("../images/background3.png")),
      input: "",
      tabcomponent: "Scatter",
      imageUrls: [
        require("../images/images_Species/CM009589.1.jpg"),
        require("../images/images_Species/CM021857.1.jpg"),
        require("../images/images_Species/CM033409.1.jpg"),
        require("../images/images_Species/MK333231.1.jpg"),
      ],
    };
  },
  created() {},
  methods: {
    handleSelectGeneHome(key) {
      switch (key) {
        case "1":
          this.tabcomponent = "Scatter";
          break;
        case "2":
          this.tabcomponent = "Heatmap";
          break;
      }
    },
    getSortTarget(str) {
      if (str == "JBrowse") {
        window.open("http://119.45.200.53:13000");
      } else if (str == "Primer3") {
        window.open("http://119.45.200.53:11235");
      } else {
        this.$router.push({ name: str });
      }
    },
    goTo(str) {
      this.$router.push({ name: str });
    },
    search() {
      this.$router.push({ name: "Genomes" });
      sessionStorage.setItem("userInputHome", this.input);
    },
  },
};
</script>

<style scoped>
.text_container {
  width: 870px;
  height: 220px;
}
.text_container .text {
  padding-top: 30px;
  font-weight: 500;
  font-family: "Times New Roman", Times, serif;
  color: #333; /* Dark gray color for the text */
  line-height: 2; /* Spacing between lines */
  font-size: 17px; /* Base font size */
  max-width: 750px; /* Maximum width of the text container */
  margin: 0 auto; /* Center the text container */
}

.text_container .text span.number {
  font-weight: bold; /* Make numbers bold */
  color: #007bff; /* A distinct blue color for numbers */
  font-size: 1.2em; /* Slightly larger size for numbers */
  background-color: #f0f0f0; /* A light gray background for numbers */
  padding: 2px 4px; /* Padding around the numbers */
  border-radius: 4px; /* Rounded corners for the background */
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2); /* Subtle shadow for depth */
}

.graph {
  margin: 10px 0 0 10px;
  width: 880px;
  height: 420px;
  border-radius: 16px !important; /* 加大圆角 */
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important; /* 同款常态立体阴影 */
}
.infosContainer {
  width: 360px;
  height: 300px;
  border: 1px solid #f0f0f0;
  font-family: "Arial", sans-serif;
  margin: 24px 0px 10px 30px;
  border-radius: 16px; /* 统一改为16px大圆角 */
  background-color: white;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12); /* 添加常态立体阴影 */
}
.body_container {
  width: 1300px;
  height: 1160px;
  margin: 10px auto;
  display: flex;
  flex-wrap: wrap;
}

.el-carousel__item .words {
  color: #475669;
  font-size: 24px;
  opacity: 0.8;
  line-height: 200px;
  margin: 0;
}
.infosTitle {
  color: #475669;
  font-size: 20px;
  opacity: 0.8;
  line-height: 50px;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  border-radius: 5px;
  background: #c9d6ff; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    rgb(201, 214, 255),
    rgb(226, 226, 226)
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    rgb(201, 214, 255),
    rgb(226, 226, 226)
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.infosTitle svg {
  width: 30px;
  height: 30px;
  margin: auto 10px;
}
.el-carousel__item:nth-child(2n) {
  background-color: white;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: white;
}
.block {
  width: 880px;
}
.leftBox {
  width: 900px;
}
.rightBox {
  width: 400px;
  margin-top: 10px;
}
.head {
  width: 1300px;
  height: 150px;
  margin: 0 auto;
}
.title {
  width: 100%;
  text-align: center;
  color: white;
  font-size: 40px;
  font-weight: 900; /* 加大到最大字重 */
  padding-top: 10px;
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.8); /* 加上深色文字阴影，确保白字在任何背景下都绝对清晰 */
}
.search {
  margin: auto;
  width: 600px;
  display: flex;
  margin-top: 10px;
}

/* 搜索框左侧半圆 */
::v-deep .search .el-input__inner {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/* 搜索按钮右侧半圆 */
::v-deep .search .el-button {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.intro {
  display: flex;
  flex-wrap: wrap;
}
.image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  display: block;
}
.introBox {
  width: 280px;
  margin: 14px auto 14px auto;
  cursor: pointer;
  border-radius: 16px !important; /* 加大圆角 */
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); /* 添加平滑的过渡动画 */
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important; /* 加强未hover时的阴影，让卡片更立体 */
}

/* 鼠标悬浮时的浮动特效和紫色阴影 */
.introBox.el-card:hover {
  transform: translateY(-4px); /* 向上浮动效果减半 */
  box-shadow: 0 10px 22px rgba(162, 155, 254, 0.5) !important; /* 紫色阴影配合浮动微调 */
}
.introTitle {
  font-size: 18px;
  font-weight: 600;
  height: 40px;
  color: #246d35;
  text-align: center;
}
.introWord {
}
.nav {
  width: 870px;
}

.info_text {
  font-family: "Arial", sans-serif; /* 使用无衬线字体 */
  color: #333; /* 文本颜色 */
  line-height: 1.6; /* 行高 */
  font-size: 16px; /* 基础字体大小 */
  margin: 8px auto;
  border-bottom: 1px solid #475669;
  width: 320px;
}
.info_essay_text {
    cursor: pointer;
}

.info_text .number {
  font-weight: bold; /* 数字加粗 */
  color: #007bff; /* 数字颜色 */
  background-color: #f0f0f0; /* 数字背景色 */
  padding: 2px 4px; /* 数字的内边距 */
  border-radius: 4px; /* 数字背景的圆角 */
  text-shadow: 0 1px 0 #fff; /* 数字的文本阴影，增加清晰度 */
}
.link-text-sby {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px; /* 根据实际需要调整宽度 */
  vertical-align: middle;
}
.twoPies {
  display: flex;
}
div::-webkit-scrollbar {
  display: none;
}
/* 垂直滚动效果 */
.scroll-container {
  overflow: hidden;
  position: relative;
}
.scroll-content {
  animation: scrollUp 15s linear infinite; /* 调整时间以改变速度 */
}
.scroll-content:hover {
  animation-play-state: paused; /* 鼠标悬停时暂停滚动 */
}
@keyframes scrollUp {
  0% { transform: translateY(0); }
  100% { transform: translateY(-50%); } /* 无缝循环的关键：只滚动到50%然后瞬间重置 */
}
</style>
